export enum ClientPeriodicity {
  Weekly = "weekly",
  Monthly = "monthly",
}
